module.exports = __webpack_public_path__ + "img/glife-order-details.17398201.png";